<template>
    <div>
        <div class="d-flex flex-row justify-content-between">
            <span class="title" v-text="title"></span>
            <span class="price" v-if="price !== undefined" v-text="formattedPrice"></span>
        </div>

        <span v-if="subTitle" class="sub-title" style="position: relative; top: -8px;" v-text="subTitle"></span>
    </div>
</template>

<script>
  export default {
    name: "OrderHeader",
    props: {
      title: {
        required: true,
        type: String,
      },
      price: {
        type: Number
      },
      subTitle: {
        type: String
      }
    },

    computed: {
      formattedPrice() {
        if(this.price !== undefined) return (this.price / 100).toFixed(2);
      }
    }
  }
</script>
